import React from 'react';

const Version = () => {
  return (
    <div style={{
      marginTop: -20,
      padding: '0px 0px 23px 63px',
      textAlign: 'left',
      color: '#999',
      fontSize: '12px'
    }}>
      v2.0.1
    </div>
  );
};

export default Version;